export default "__VITE_ASSET__C3nK_3N2__"